/**
 * Roles com acesso total ao sistema
 */
export const ADMIN_ROLES = ['Admin', 'admin', 'afericoes.admin'];

/**
 * Roles com acesso limitado (Gerentes e Coordenadores)
 * Inclui variações de case para compatibilidade
 */
export const LIMITED_ROLES = [
  'Gerente', 
  'gerente', 
  'Supervisor', 
  'supervisor', 
  'Coordenador',
  'coordenador',
  'afericoes.gerente', 
  'afericoes.supervisor',
  'afericoes.coordenador'
];


export const COORDENADOR_ROLES = ['Coordenador', 'coordenador', 'afericoes.coordenador'];

/**
 * Todas as roles válidas
 */
export const ALL_ROLES = [...ADMIN_ROLES, ...LIMITED_ROLES];

/**
 * Verifica se o usuário tem acesso total (Admin ou afericoes.admin)
 * @param {string} role - Role do usuário
 * @returns {boolean}
 */
export function hasFullAccess(role) {
  return ADMIN_ROLES.includes(role);
}

/**
 * Verifica se o usuário tem acesso limitado
 * @param {string} role - Role do usuário
 * @returns {boolean}
 */
export function hasLimitedAccess(role) {
  return LIMITED_ROLES.includes(role);
}

/**
 * Verifica se a role é válida
 * @param {string} role - Role do usuário
 * @returns {boolean}
 */
export function isValidRole(role) {
  return ALL_ROLES.includes(role);
}

/**
 * Mapeia roles antigas para novas (para compatibilidade)
 * @param {string} role - Role do usuário
 * @returns {string} Role mapeada
 */
export function mapLegacyRole(role) {
  const roleMap = {
    'Manager': 'Gerente',
    'Supervisor': 'Supervisor',
  };
  return roleMap[role] || role;
}

